import React from 'react';

import Button from '../../common/button/Button';

import HeaderContainer from '../../../containers/header/Header.container';
import BadgeSettingsContainer from '../../../containers/settings/badge/BadgeSettings.container';

import './settings.scss';

type Props = {
  navigateBack: () => void;
};

const Settings = ({ navigateBack }: Props) => {
  return (
    <section className="settings">
      <HeaderContainer />

      <div className="settings__header">
        <h1>Settings</h1>
      </div>

      <section className="settings__container">
        <section className="settings__content">
          <BadgeSettingsContainer />
        </section>

        <section className="settings__button">
          <Button text="Back" onClick={navigateBack} />
        </section>
      </section>

      <div className="settings__footer" />
    </section>
  );
};

export default Settings;
